import * as Yup from 'yup';
import { type UpsertPropertySpaceFormProps } from './UpsertPropertySpaceForm';

const upsertPropertySpaceValidationSchema = (space: UpsertPropertySpaceFormProps['space']) => {
  const sizeBaseSchema = Yup.number().integer('Inserisci un numero intero').positive('Inserisci un numero positivo');

  let floorSchema = Yup.number();

  switch (space) {
    case 'cellar':
      floorSchema = floorSchema.lessThan(1, 'Il piano deve essere minore o uguale a 0');
      break;
    case 'terrace':
      floorSchema = floorSchema.moreThan(-1, 'Il piano deve essere maggiore o uguale a 0');
      break;
    case 'balcony':
      floorSchema = floorSchema.moreThan(0, 'Il piano deve essere maggiore di 0');
      break;
    default:
      break;
  }

  return Yup.object({
    size: space === 'garden'
      ? sizeBaseSchema.required('Il campo è obbligatorio')
      : sizeBaseSchema,
    floor: floorSchema,
  });
};

export default upsertPropertySpaceValidationSchema;
